/**
 *  Loads data for locations & information sessions and displays location information,
 *  & provides form to submit to CRM.
 *
 *  @module information-sessions
 *
 */

/* global XMLHttpRequest, LOCATIONS_API_BASE, SESSIONS_API_BASE */
import axios from 'axios'

const validEventTypes = ['infosession', 'openhouse', 'admissions-fa-workshop', 'orientation-rsvp']
const regions = ['Capital District', 'Central NY', 'Finger Lakes', 'Long Island', 'Mid-Hudson', 'Mohawk Valley', 'New York City - Brooklyn', 'New York City - Manhattan', 'New York City - Staten Island', 'North Country', 'Southern Tier', 'Western NY']
const communityColleges = ['New York State Community Colleges', 'Out of State Community Colleges']
const areasOfStudy = ['Degrees in Business,  Management and Economics', 'Degrees in Business, Management and Economics', 'Degrees in Community and Human Services', 'Degrees in Educational Studies', 'Degrees in Public Affairs', 'Degrees in Technology']
const programs = ['OVME', 'Veteran, Military and Spouses Information Session', 'graduate', 'Nursing and Allied Health', 'NYSED Title IIA Partnership']
const graduatePrograms = ['Business, Management & Leadership Programs', 'Ed.D. in Educational Leadership & Change', 'Education Programs', 'Liberal Arts and Science Programs']
const other = ['Out of Country', 'Out of State', 'Out of State or Country']
const nursingAlliedHealth = ['nursing-bs', 'nursing-msn', 'allied-health']
const allRegions = regions.concat(communityColleges, areasOfStudy, programs, graduatePrograms, other, nursingAlliedHealth)
const crmEventBase = 'https://esc.elluciancrmrecruit.com/Apply/Events/EventDetails?eventId='

const browser = require('detect-browser')
const { name } = browser
const myBrowser = name

let nearestLocation
let locationsData

const sites = []
const siteNames = []
const nonRegionSitesWithSession = []

let sessions

let eventType, eventDate
if (validEventTypes.indexOf(window.eventType) >= 0) {
  eventType = window.eventType
  eventDate = window.eventDate
}

/* Add base path based on environment */
const locationsAPI = LOCATIONS_API_BASE + '/geo'
const locationsByDistanceAPI = LOCATIONS_API_BASE + '/nearestOne'
const getSessionsAPI = SESSIONS_API_BASE + '/' + eventType + '/open-recruit/45/region'

/**
 * Initialize environment
 *
 */
let qsLocation
const querystring = require('querystring')
const qs = querystring.parse(document.URL.split('?')[1])
if (qs.l) qsLocation = qs.l

document.addEventListener('DOMContentLoaded', function () {
  setWatchers()
  initPage(locationsAPI)
})

/**
 * Watch selectors and update update dependent data as needed.
 *
 * @returns void
 */
function setWatchers () {
  const crm = document.querySelector('#crm')
  const locationGroup = document.querySelector('#location-group')

  if (eventType === 'admissions-fa-workshop') {
    locationGroup.addEventListener('change', function (event) {
      if (event.type === 'change') {
        const loc = document.querySelector('#location')
        const fortDrumWarning = document.querySelector('.warning-fort-drum')
        const outOfStateWarning = document.querySelector('.warning-out-of-state')
        switch (loc.value) {
          case 'Fort Drum':
            outOfStateWarning.classList.add('hidden')
            fortDrumWarning.classList.remove('hidden')
            crm.classList.remove('disabled')
            break
          case 'out-of-state':
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.remove('hidden')
            crm.classList.add('disabled')
            break
          case 'select-location':
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.add('hidden')
            crm.classList.add('disabled')
            break
          default:
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.add('hidden')
            crm.classList.remove('disabled')
            break
        }

        window.dataLayer.push({ escEventLocation: loc.value })
        setSessions(loc.value)
        const { options } = event.target
        const { selectedIndex } = options
        const selectValue = options[selectedIndex].dataset.url

        crm.setAttribute('href', selectValue)
      }
    })
  } else {
    locationGroup.addEventListener('change', function (event) {
      if (event.type === 'change') {
        crm.classList.add('disabled')
        const loc = document.querySelector('#location')
        const fortDrumWarning = document.querySelector('.warning-fort-drum')
        const outOfStateWarning = document.querySelector('.warning-out-of-state')
        switch (loc.value) {
          case 'Fort Drum':
            outOfStateWarning.classList.add('hidden')
            fortDrumWarning.classList.remove('hidden')
            break
          case 'out-of-state':
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.remove('hidden')
            break
          case 'use-my-location':
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.add('hidden')
            useMyLocation()
            break
          default:
            fortDrumWarning.classList.add('hidden')
            outOfStateWarning.classList.add('hidden')
            break
        }

        window.dataLayer.push({ escEventLocation: loc.value })
        setSessions(loc.value)
      }
    })

    const sessionGroup = document.querySelector('#session-group')
    sessionGroup.addEventListener('change', function (event) {
      if (event.type === 'change') {
        crm.setAttribute('href', event.target.getAttribute('data-url'))
        crm.classList.remove('disabled')
      }
    })
  }
}

/**
 * Initialize page by loading available locations
 *
 * @param locationsAPI URL of API for locations data.
 */
function initPage (locationsAPI) {
  if (eventType === 'infosession') {
    axios.get(getSessionsAPI)
      .then(function (response) {
        sessions = response.data.data
        Object.keys(sessions).forEach(function (location) {
          if (!regions.includes(location)) {
            nonRegionSitesWithSession.push(location)
          }
        })
      })

    axios.get(locationsAPI)
      .then(function (response) {
        locationsData = response.data
        const options = locationOptions()
        const loc = document.querySelector('#location')
        loc.innerHTML = options
      })

  } else if (eventType === 'openhouse') {
    loadJSON(locationsAPI, function (response) {
      locationsData = JSON.parse(response.toString())
      locationsData.features.forEach(function (site) {
        sites[site.properties.name] = site
        siteNames.push(site.properties.name)
      })
    })
    loadJSON(getSessionsAPI, successOpenHouseSessions)
  } else if (eventType === 'admissions-fa-workshop') {
    loadJSON(getSessionsAPI, function (response) {
      const sessionsData = JSON.parse(response.toString())
      sessions = sessionsData.data
      const options = admissionsFAWorkshopLocationOptions()
      const loc = document.querySelector('#location-group')
      loc.innerHTML = options
    })
  } else if (eventType === 'orientation-rsvp') {
    loadJSON(getSessionsAPI, function (response) {
      const sessionsData = JSON.parse(response.toString())
      sessions = sessionsData.data
      const options = orientationRsvpLocationOptions()
      const loc = document.querySelector('#location-group')
      loc.innerHTML = options
    })
  }
}
/* Demo CODE */
// function resolveAfter2Seconds() {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve('resolved');
//     }, 2000);
//   });
// }
//
// async function asyncCall() {
//   console.log('calling');
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   // expected output: "resolved"
// }
//
// asyncCall();
/* END Demo CODE */

function displayAddress (site) {
  const building = (typeof sites[site].properties.building !== 'undefined') ? sites[site].properties.building + ', ' : ''
  return (
    building +
    sites[site].properties.address +
    ', ' +
    sites[site].properties.city +
    ', ' +
    sites[site].properties.state +
    ' ' +
    sites[site].properties.zip)
}

/**
 * On successful load of locations, set location and load sessions.
 *
 * @param {JSON} response Location data loaded
 */
function successLocations (response) {
  locationsData = JSON.parse(response.toString())

  if (sites !== {} && eventType === 'infosession') {
    loadJSON(getSessionsAPI, successSessions)
  } else if (sites !== {} && eventType === 'openhouse') {
    loadJSON(getSessionsAPI, successOpenHouseSessions)
  }

  setLocation()
}

/**
 * jQuery select to update location data
 *
 */
function setLocation () {
  const loc = document.querySelector('#location')
  loc.innerHTML = locationOptions()
}

/**
 * Format HTML of available locations to be inserted
 *
 * @return {string} HTML to be inserted
 */
function locationOptions () {
  let html = '<select id="location" name="location" class="form-control" >'
  if (typeof locationsData !== 'undefined') {
    siteNames.push('graduate', 'OVME', 'allied-health', 'nursing-bs', 'nursing-msn', 'out-of-state')

    html += '<option value="">Select a Region or Program</option>\n'

    html += '<optgroup label="Sessions by Program &amp; Affiliation">\n'
    if (sessions['Nursing and Allied Health']) {
      html += '<option value="Nursing and Allied Health">Nursing and Allied Health</option>\n'
    }
    if (sessions['Veteran, Military and Spouses Information Session']) {
      html += '<option value="Veteran, Military and Spouses Information Session">Veteran, Military, Spouses and Fort Drum</option>\n'
    }
    if (sessions['NYSED Title IIA Partnership']) {
      html += '<option value="NYSED Title IIA Partnership">NYSED Title IIA Partnership</option>\n'
    }
    html += '</optgroup>\n'

    html += '<optgroup label="Undergraduate Sessions by Region">\n'
    Object.keys(sessions).forEach(function (region) {
      if (regions.includes(region)) {
        html += '<option>' + region + '</option>\n'
      }
    })
    html += '<option value="Out of State or Country">Out of State</option>\n'
    html += '<option value="Out of State or Country">Out of Country</option>\n'
    html += '</optgroup>\n'
    html += sessionsByLocation()

    html += '<optgroup label="Master\'s Degree and Advanced Certificates">\n'
    Object.keys(sessions).forEach(function (region) {
      if (graduatePrograms.includes(region)) {
        html += '<option>' + region + '</option>\n'
      }
    })
    html += '</optgroup>\n'

    html += '<optgroup label="Areas of Study">\n'
    Object.keys(sessions).forEach(function (region) {
      if (areasOfStudy.includes(region)) {
        html += '<option>' + region + '</option>\n'
      }
    })
    html += '</optgroup>\n'

    html += '<optgroup label="Community Colleges">\n'
    Object.keys(sessions).forEach(function (region) {
      if (communityColleges.includes(region)) {
        html += '<option>' + region + '</option>\n'
      }
    })
    html += '</optgroup>\n'
  }
  html += '</optgroup>\n'

  // html += '<option value="use-my-location">Use My Location to Find Nearest Site</option>\n'
  html += '</select>\n'
  return html
}

function sessionsByLocation () {
  let html = '<optgroup label="Undergraduate Sessions by Location">\n'
  let count = 0
  locationsData.features.forEach(function (site) {
    const { informationSessionsEnabled, name } = site.properties
    sites[name] = site
    siteNames.push(name)
    if (informationSessionsEnabled && nonRegionSitesWithSession.includes(name)) {
      count += 1
      html += '<option>' + name + '</option>\n'
    }
  })
  if (count >= 1) {
    return html
  } else {
    return null
  }
}

/**
 * Format HTML of available locations to be inserted
 *
 * @return {string} HTML to be inserted
 */
function openHouseLocationOptions () {
  let html = '<select id="location" name="location" class="form-control" >'
  if (typeof sessions !== 'undefined') {
    html += '<option value="">Select Location</option>\n'
    html += '<option value="out-of-state">Outside New York State</option>\n'
    html += '<optgroup label="SUNY Empire State College Locations">\n'

    Object.keys(sessions).forEach(function (site) {
      html += '<option>' + site + '</option>\n'
    })
  }
  html += '</optgroup>\n'
  html += '<option value="use-my-location">Use My Location to Find Nearest Site</option>\n'
  html += '</select>'
  return html
}

/**
 * Format HTML of available locations to be inserted
 *
 * @return {string} HTML to be inserted
 */
function admissionsFAWorkshopLocationOptions () {
  let html
  const { featureCount } = sessions
  if (featureCount !== 0) {
    html = '<select id="location" name="location" class="form-control" >'
    html += '<option value="select-location">Select Session</option>\n'

    Object.keys(sessions).forEach(function (site) {
      if (site !== 'Virtual') {
        const url = sessions[site][eventDate][0].url
        const urlParts = url.split('=')
        const eventId = urlParts[1]
        // const dataUrl = crmEventBase + eventId
        const dataUrl = url
        html += '<option data-url="' + dataUrl + '">' + site + '</option>\n'
      }
    })

    html += '</select>'
  } else {
    html = '<p>No workshops currently scheduled</p>'
  }
  return html
}

/**
 * Format HTML of available locations to be inserted
 *
 * @return {string} HTML to be inserted
 */
function orientationRsvpLocationOptions () {
  let html
  const { featureCount } = sessions
  if (featureCount !== 0) {
    html = '<select id="location" name="location" class="form-control" >'
    html += '<option value="select-location">Select Session</option>\n'

    Object.keys(sessions).forEach(function (site) {
      html += '<option>' + site + '</option>\n'
    })

    html += '</select>'
  } else {
    html = '<p>No workshops currently scheduled</p>'
  }
  return html
}

/**
 * On successful load of Sessions, start geolocation
 *
 * @param {JSON} response Session data loaded
 */
function successSessions (response) {
  sessions = JSON.parse(response.toString()).data
  Object.keys(sessions).forEach(function (location) {
    if (!regions.includes(location)) {
      nonRegionSitesWithSession.push(location)
    }
  })

  // if (siteNames.includes(qsLocation)) {
  //   const loc = document.querySelector('#location')
  //   loc.value = qsLocation
  //   const event = new Event('change')
  //   const locationGroup = document.querySelector('#location-group')
  //   locationGroup.dispatchEvent(event)
  //   setSessions(qsLocation)
  // }
}

function useMyLocation () {
  if (navigator.geolocation && myBrowser !== 'ie') {
    /* geolocation is available */
    const geoOptions = {
      enableHighAccuracy: true,
      maximumAge: 30000,
      timeout: 27000
    }
    navigator.geolocation.getCurrentPosition(
      successPosition,
      failPosition,
      geoOptions
    )
  } else {
    /* geolocation IS NOT available */
    console.log('GeoLocation not available.')
  }
}

/**
 * On successful load of Open House Sessions
 *
 * @param {JSON} response Session data loaded
 */
function successOpenHouseSessions (response) {
  sessions = JSON.parse(response.toString()).data
  const options = openHouseLocationOptions()
  const loc = document.querySelector('#location')
  loc.innerHTML = options
}

/**
 * If geolocation succeeds, get distances and set location to nearest.
 *
 * @param position
 */
function successPosition (position) {
  const url =
    locationsByDistanceAPI +
    '/' +
    position.coords.longitude +
    '/' +
    position.coords.latitude
  loadJSON(url, function (response) {
    const nearestSite = JSON.parse(response)
    nearestLocation = nearestSite.data[0].properties.name
    if (typeof qsLocation === 'undefined' && typeof nearestLocation !== 'undefined') {
      const loc = document.querySelector('#location')
      loc.value = nearestLocation
      const event = new Event('change')
      const locationGroup = document.querySelector('#location-group')
      locationGroup.dispatchEvent(event)
      window.dataLayer.push({ location: nearestLocation })
      setSessions(nearestLocation)
    }
  })
}

/**
 * If geolocation fails, log if SSL issue. If location specified in URL, load that instead.
 *
 * @param {Object} failure Result from geolocation attempt
 * @return {null}
 */
function failPosition (failure) {
  if (failure.message.indexOf('Only secure origins are allowed') === 0) {
    // Secure Origin issue.
    console.log(failure.message)
  }
  if (siteNames.includes(qsLocation)) {
    const loc = document.querySelector('#location')
    loc.value = qsLocation
    const event = new Event('change')
    const locationGroup = document.querySelector('#location-group')
    locationGroup.dispatchEvent(event)
    setSessions(qsLocation)
  }
  return null
}

/**
 * jQuery select to update session data, trigger updates of location information.
 *
 * @param {string} site Selected location for which to insert sessions
 */
export function setSessions (site) {
  let options
  const session = document.querySelector('#session')
  session.innerHTML = ''
  if (eventType === 'infosession') {
    options = infoSessionOptions(site)
  } else if (eventType === 'openhouse') {
    options = openHouseOptions(site)
  } else if (eventType === 'orientation-rsvp') {
    options = orientationRsvpOptions(site)
  }
  if (typeof options === 'string') {
    session.innerHTML = options
  }
}

/**
 * Format HTML available information session times for selected location
 *
 * @param {string} location Selected location
 * @return {string} HTML to be inserted
 */
function infoSessionOptions (location) {
  if (allRegions.includes(location)) {
    return sessionsByRegion(location)
  } else {
    return sessionOptions(location)
  }
}

function sessionsByRegion (region) {
  const now = new Date()
  let count = 0
  let displayLocation
  let html = '<label title="Session" for="session">Select a Session Date &amp; Time Below<span class="required">*</span></label>'
  html += '<dl>\n'
  Object.keys(sessions[region]).forEach(function (site) {
    html += '<dt>' + site + '</dt>\n'

    if (typeof sessions[region][site] !== 'undefined') {
      Object.keys(sessions[region][site]).forEach(function (startdatetime) {
        const { url, mode } = sessions[region][site][startdatetime]
        if (typeof sessions[region][site][startdatetime]['alternate-location'] !== 'undefined') {
          displayLocation =
            ' (' + sessions[region][site][startdatetime]['alternate-location'] + ')'
        } else {
          displayLocation = ''
        }
        const urlParts = url.split('=')
        const eventId = urlParts[1]
        // const dataUrl = crmEventBase + eventId
        const dataUrl = url
        const isOnline =
          mode &&
          mode.toLowerCase() === 'virtual'
        const onlineDisplay = ', Online'
        const displayOnline = isOnline ? onlineDisplay : ''
        const date = new Date(startdatetime)
        const showDate = date.toLocaleTimeString([], {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short'
        })
        const checked = eventType === 'infosession' ? null : 'checked'
        if (date > now) {
          count++
          html +=
            '<dd class="radio"><label><input type="radio" name="session" ' +
            checked +
            ' data-url="' +
            dataUrl +
            '" value="' +
            startdatetime +
            '"/>' +
            showDate +
            displayLocation +
            displayOnline +
            '</label></dd>\n'
        }
      })

    } else {
      html += '<input type="radio" name="session" class="hidden" />'
    }

    if (typeof sites[site] !== 'undefined') {
      const { formDisabled } = sites[site].properties
      if (count === 0 && typeof sites[site] !== 'undefined' && formDisabled !== true) {
        html += '<p><em>No Information Sessions currently scheduled.</em></p>\n'
      }
    }
  })
  html += '</dl>'
  html += '</div>'

  return html
}

/**
 * OLD Format HTML available information session times for selected location
 *
 * @param {string} site Selected location
 * @return {string} HTML to be inserted
 */
function sessionOptions (site) {
  const now = new Date()
  let count = 0
  let displayLocation
  let html = ''

  if (typeof sites[site] !== 'undefined') {
    const { appointment } = sites[site].properties
    if (typeof appointment !== 'undefined') {
      const { description, building } = appointment
      if (
        eventType === 'infosession' &&
        typeof building === 'undefined' &&
        typeof description !== 'undefined'
      ) {
        html += description + '\n'
      }
    }
  }

  if (typeof sessions[site] !== 'undefined') {
    html +=
      '<label title="Session" for="session">Select a Session Date &amp; Time Below<span class="required">*</span></label>'

    Object.keys(sessions[site]).forEach(function (startdatetime) {
      const { url, mode } = sessions[site][startdatetime]
      if (typeof sessions[site][startdatetime]['alternate-location'] !== 'undefined') {
        displayLocation =
          ' (' + sessions[site][startdatetime]['alternate-location'] + ')'
      } else {
        displayLocation = ''
      }
      const urlParts = url.split('=')
      const eventId = urlParts[1]
      // const dataUrl = crmEventBase + eventId
      const dataUrl = url
      const isOnline =
        mode &&
        mode.toLowerCase() === 'virtual'
      const onlineDisplay = ', Online'
      const displayOnline = isOnline ? onlineDisplay : ''
      const date = new Date(startdatetime)
      const showDate = date.toLocaleTimeString([], {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      })
      const checked = eventType === 'infosession' ? null : 'checked'
      if (date > now) {
        count++
        html +=
          '<div class="radio"><label><input type="radio" name="session" ' +
          checked +
          ' data-url="' +
          dataUrl +
          '" value="' +
          startdatetime +
          '"/>' +
          showDate +
          displayLocation +
          displayOnline +
          '</label></div>\n'
      }
    })
  }

  if (typeof sites[site] !== 'undefined') {
    const { formDisabled } = sites[site].properties
    if (count === 0) {
      html += '<p><em>No Information Sessions currently scheduled.</em></p>\n'
    }
  }
  return html
}

/**
 * Format HTML available open house times for selected location
 *
 * @param {string} site Selected location
 * @return {string} HTML to be inserted
 */
function openHouseOptions (site) {
  const now = new Date()
  let displayLocation
  let html = '<div id="session">'

  if (typeof sessions[site] !== 'undefined') {
    html +=
      '<label title="Session" for="session">Select your session below<span class="required">*</span></label>'

    Object.keys(sessions[site]).forEach(function (startdatetime) {
      const iMax = sessions[site][startdatetime].length
      let academicLevel
      for (let i = 0; i < iMax; i++) {
        const { url, academic_level: level, mode } = sessions[site][startdatetime][i]

        switch (level) {
          case 'graduate':
            academicLevel = 'Graduate, '
            break
          case 'undergraduate':
            academicLevel = 'Undergraduate, '
            break
          default:
            academicLevel = ''
        }

        if (mode !== 'virtual') {
          displayLocation = '<p>' + displayAddress(site) + '</p>'
        } else {
          displayLocation = ''
        }
        const urlParts = url.split('=')
        const eventId = urlParts[1]
        // const dataUrl = crmEventBase + eventId
        const dataUrl = url
        const isOnline =
          mode &&
          mode.toLowerCase() === 'virtual'
        const onlineDisplay = ', Online'
        const displayOnline = isOnline ? onlineDisplay : ''
        const date = new Date(startdatetime)
        const showDate = date.toLocaleTimeString([], {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short'
        })

        if (date > now) {
          html +=
            '<div class="radio"><label><input type="radio" name="session" ' +
            ' data-url="' +
            dataUrl +
            '" value="' +
            startdatetime +
            '"/>' +
            academicLevel +
            showDate +
            displayOnline +
            '</label>' + displayLocation + '</div>\n'
        }
      }
    })
  } else {
    html += '<input type="radio" name="session" class="hidden" />'
  }
  html += '</div>'
  return html
}

/**
 * Format HTML available Orientation RSVP times for selected location
 *
 * @param {string} site Selected location
 * @return {string} HTML to be inserted
 */
function orientationRsvpOptions (site) {
  const testDate = new Date()
  const cutoff = Number (testDate.getHours()) + Number(2)
  testDate.setHours(cutoff)

  let html = ''

  if (typeof sessions[site] !== 'undefined') {
    html = '<label title="Session" for="session">Select your session below<span class="required">*</span></label>'

    const keys = Object.keys(sessions[site])
    keys.forEach(function (startdatetime) {
      const { name } = sessions[site][startdatetime]

      // const isOnline = mode && mode.toLowerCase() === 'virtual'
      // const onlineDisplay = ', Online'
      // const displayOnline = isOnline ? onlineDisplay : ''

      const displayEventName = ',<br />' + name + ' '

      const date = new Date(startdatetime)
      const showDate = date.toLocaleTimeString([], {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      })

      if (date > testDate) {
        html +=
          '<div class="radio"><label><input type="radio" name="session" ' +
          ' value="' +
          startdatetime +
          '"/>' +
          showDate +
          displayEventName +
          '</label></div>\n'
      }

    })
  } else {
    html += '<input type="radio" name="session" class="hidden" />'
  }
  return html
}

/**
 * Utility to load JSON data asynchronously
 *
 * @param {string} path Location of data to load
 * @param {Function} callback Function to call on successful load
 */
function loadJSON (path, callback) {
  const xobj = new XMLHttpRequest()
  //    xobj.overrideMimeType("application/json");  // IE 10 Incompatibility :-(
  xobj.open('GET', path, true)
  xobj.onreadystatechange = function () {
    if (xobj.readyState === 4 && xobj.status === 200) {
      callback(xobj.responseText)
    }
  }
  xobj.send(null)
}
